import script from "./MoleculeTableSmall.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTableSmall.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTableSmall.vue?vue&type=style&index=0&id=046a251f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-046a251f"]])

export default __exports__